<template>

  <t-page>

    <t-gallery :images="galleryImages" v-if="galleryShow" v-model="galleryShow" title="Imagens do Produto"/>

    <t-page-list :title="t('list-of') + currentPage.pageTitle" :user-auth="userAuth"
                 :total-pages="request.totalPages" :total-elements="request.totalElements" @getPage="getPage">


      <template #search>

        <t-button v-if="userAuth.validation.validationCreate" :text="t('insert') + ' ' + currentPage.singularTitle"
                  :to="currentPage.name + '-form-new'"
                  primary/>


        <t-content-header-search-default @searchChange="searchDefault"
                                         @onClearSearch="clearSearch()"
                                         :fields-custom="entityFieldCustomized('page')"
                                         placeholder="Cód. Produto, Nome"
                                         :filtered-default="filteredDefault" :filtered-advanced="filteredAdvanced"
                                         :search-form="form">

          <t-input-search v-model="form.model" label="Modelo"/>

          <t-input-search v-model="form.groupProductId"
                          :options="groupProductOptions"
                          label="Grupo de produtos"
                          select/>

        </t-content-header-search-default>

        <!--
        {{ exemplo }}

        <b-col cols="6">
          <t-input-product required v-model="exemplo"/>
        </b-col>-->

      </template>

      <t-table :show="checkViewListTableDefault()" @reload="reloadPageList()"
               :filtered="checkIsFiltered()"
               :busy="!pageListIsLoaded"
               :items="request.content"
               :user-auth="userAuth"
               :fields="userAuth.viewFields"
               link-primary-column="productCodeLabel"
               primary-key-column="productNumber">


        <template #item(qtyImagesGeneral)="{item}">

          <t-button small @click="openModalProductImages(item.productId)">
            <b-icon-camera/>
          </t-button>

        </template>

        <template #item(firstFileName)="{item}">

          <t-button v-if="item.firstFileName !== ''" small outline-light @click="openModalProductImages(item.productId)">
            <t-image-blob style="max-width: 50px;"
                          :src="'product/item-file/image/'+item.productId+'/'+item.firstFileId+'/?variant=thumbnail'"
                          class="align-self-center"/>

          </t-button>
          <small v-else>-</small>

        </template>

      </t-table>


    </t-page-list>

  </t-page>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageListMixin from "@/mixins/page/pageListMixin"
import groupProductService from "@/services/modules/product/GroupProduct.service";
import pageListEmbeddableMixin from "@/mixins/page/pageListEmbeddableMixin";
import tImageBlob from "@/components/template/theme/t-image-blob"
import productService from "@/services/modules/product/Product.service";
import TGallery from "@/components/template/page/t-gallery";

export default {
  components: {tImageBlob, TGallery},
  mixins: [pageDefaultMixin, pageListMixin, pageListEmbeddableMixin],
  name: 'ProductEmbeddable',
  data() {
    return {
      enableGeneralFields: true,
      path: "product",
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      groupProductOptions: [],
      galleryShow: false,
      galleryImages: [],
      //--------------------------------------------------------------------------------------

    }
  },
  methods: {

    mountedPrepare() {


    },
    async mountedContinued() {

      await groupProductService.selectList("grouped").then((list) => {
        this.groupProductOptions = list
      }).catch(error => this.responseError(error))

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela
    openModalProductImages(id) {

      productService.getImages(id).then((response) => {

        this.galleryShow = true
        this.galleryImages = response

      }).catch(error => this.responseError(error))


    }
    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedList()

    await this.mountedContinued()

  },
}
</script>
